import type { CommitteeNode } from '../../hooks/useCommitteeHierarchy'

export interface CommitteeOption {
  id: string
  label: string
  depth: number
}

/**
 * WL-5: flatten the nested committee tree from `my-hierarchy` into a depth-tagged, de-duplicated
 * list the switcher renders as indented `<option>`s. Depth-first so a child sits directly under its
 * parent; deduped by id (a repeated committee is duplicate data, not two rows) and cycle-guarded so a
 * malformed tree can never spin or flood React with duplicate-key warnings.
 */
export function flattenCommitteeOptions(children: CommitteeNode[]): CommitteeOption[] {
  const seen = new Set<string>()
  const out: CommitteeOption[] = []

  const walk = (nodes: CommitteeNode[], depth: number) => {
    for (const node of nodes) {
      if (seen.has(node.id)) continue
      seen.add(node.id)
      out.push({ id: node.id, label: node.label, depth })
      if (node.children && node.children.length > 0) walk(node.children, depth + 1)
    }
  }

  walk(children, 0)
  return out
}
